import { withAuthenticationRequired } from '@auth0/auth0-react';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useRoutes } from 'react-router-dom';

import { home, MainRoutes, MobileRoutes } from './MainRoutes';
import { CustomPermission } from '../@types';
import { MainMenuItem } from '../components/molecules/Drawer/Drawer.props';
import { menuData } from '../configs/menu';
import { permittedLayouts, permittedRoutes, RouteConfig } from '../configs/permissions';
import { useGetUserSystemPermissions } from '../queries/user-query';

const MOBILE_UA_REGEX = /Android|iPhone|iPad|iPod|webOS|BlackBerry|Opera Mini|IEMobile/i;
const MOBILE_REDIRECT_KEY = 'mobile_redirected';

const ThemeRoutes = () => {
  const [permissions, setPermissions] = useState<CustomPermission[]>();
  const navigate = useNavigate();
  const location = useLocation();
  let layoutes: MainMenuItem[] = [];

  // Redirect mobile devices to /mobile/services on first visit
  useEffect(() => {
    const alreadyRedirected = sessionStorage.getItem(MOBILE_REDIRECT_KEY);
    const isMobileUA = MOBILE_UA_REGEX.test(navigator.userAgent);
    const isAlreadyOnMobile = location.pathname.startsWith('/mobile');

    if (isMobileUA && !alreadyRedirected && !isAlreadyOnMobile) {
      sessionStorage.setItem(MOBILE_REDIRECT_KEY, 'true');
      navigate('/mobile/services', { replace: true });
    }
  }, []);

  const getUserPermissionsQuery = useGetUserSystemPermissions();

  useEffect(() => {
    if (getUserPermissionsQuery.isSuccess && getUserPermissionsQuery.data) {
      setPermissions(getUserPermissionsQuery.data);
    }
  }, [getUserPermissionsQuery.isLoading, getUserPermissionsQuery.isSuccess]);

  if (permissions) {
    layoutes = permittedLayouts(menuData, permissions);
  }

  const filteredRoutes: RouteConfig = permittedRoutes(layoutes, MainRoutes);
  filteredRoutes.children.push(home);

  const routes = useRoutes([filteredRoutes, MobileRoutes]);

  // Show nothing while permissions are loading to prevent
  // the home page flashing before the target route renders.
  if (!permissions) return null;

  return routes;
};

export default withAuthenticationRequired(ThemeRoutes);
